import { Tabs } from '#components/tabs/tabs.js';
import { UnderlineTab } from '#components/tabs/underline-tab.js';
import { SidePanelTab } from './side-panel-tab.js';

import type { ReactNode } from 'react';
import type { TabDef } from '#components/tabs/tabs.js';

/** A side panel tab, identified by the view it shows. */
interface SidePanelTabDef extends TabDef {
	id: SidePanelTab;
}

/** The side panel's tabs that are always offered, in display order. */
const FIXED_TABS: SidePanelTabDef[] = [
	{ id: SidePanelTab.Workbench, label: 'Workbench' },
	{ id: SidePanelTab.Evidence, label: 'Evidence' },
];

/** Props for {@link SidePanelTabs}. */
export interface SidePanelTabsProps {
	/** The view the panel is showing. */
	selectedTab: SidePanelTab;
	/** Called with the view the viewer chose. */
	onSelectedTabChange: (tab: SidePanelTab) => void;
	/** Shown at the strip's trailing edge while the Workbench tab is selected, e.g. a switch between workbench modes. */
	workbenchTabAdornment?: ReactNode;
}

/**
 * The header strip of a workbench side panel: its Workbench and Evidence tabs, plus any control that
 * belongs to the workbench alone. The panel renders the selected view beneath it.
 */
export function SidePanelTabs({ selectedTab, onSelectedTabChange, workbenchTabAdornment }: SidePanelTabsProps) {
	const showAdornment =
		selectedTab === SidePanelTab.Workbench && workbenchTabAdornment !== undefined && workbenchTabAdornment !== null;

	return (
		<div className='flex shrink-0 items-end justify-between gap-2 border-b border-gray-a3 px-3'>
			<Tabs
				tabs={FIXED_TABS}
				selectedTab={selectedTab}
				onSelectedTabChange={onSelectedTabChange}
				renderTab={(props) => <UnderlineTab {...props} />}
			/>
			{showAdornment && <div className='flex self-center'>{workbenchTabAdornment}</div>}
		</div>
	);
}
